import { Grid, IconButton } from '@mui/material';
import Iconify from 'src/components/Iconify';

const Label = (props: any) => {
  const { record, checklistItem, metasResponse, handler, allowEdit } = props?.others;
  const { message } = metasResponse;

  return (
    <Grid
      id={`outlined-${props?.name || props?.elementName}`}
      container
      direction="row"
      alignItems="center"
      flexWrap="nowrap"
    >
      <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ fontSize: 12 }}>{message}</span>
      </Grid>
      {allowEdit && (
        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            size="small"
            onClick={() =>
              handler({
                record,
                checklistItem,
              })
            }
          >
            <Iconify icon="eva:edit-outline" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default Label;
